export const DEFAULT_STOP = 500;
export const DEFAULT_MODE = "hex";
export const DEFAULT_STOPS = [
    0, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950, 1000,
];

export const MODES = [`hex`, `p-3`, "oklch"];

export const DEFAULT_PALETTE_CONFIG = {
    id: ``,
    name: ``,
    value: ``,
    valueStop: DEFAULT_STOP,
    swatches: [],
    h: 0,
    s: 0,
    lMin: 0,
    lMax: 100,
    useLightness: false,
    mode: MODES[0],
};
